import instructionsForUsePdf from 'assets/static/Instructions_for_use.pdf'
import { useTranslation } from 'react-i18next'

const IfuPage = () => {
    const { t } = useTranslation('pages')

    return (
        <div
            style={{
                width: '100%',
                height: 'calc(100vh - 120px)',
                padding: '16px'
            }}
        >
            <iframe
                src={instructionsForUsePdf}
                title={t('ifu.title')}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
            />
        </div>
    )
}

export default IfuPage
